import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { formatPhoneNumber, getTelLink } from './utils';
import CommunicationAdditionalInfo from './CommunicationAdditionalInfo';
import _ from 'lodash';
var PhoneNumberDisplay = /*#__PURE__*/function (_Component) {
  _inherits(PhoneNumberDisplay, _Component);
  var _super = _createSuper(PhoneNumberDisplay);
  function PhoneNumberDisplay() {
    _classCallCheck(this, PhoneNumberDisplay);
    return _super.apply(this, arguments);
  }
  _createClass(PhoneNumberDisplay, [{
    key: "formattedPhoneLink",
    value: function formattedPhoneLink(phoneNumber) {
      var _this$props = this.props,
        hidePrimaryDisplay = _this$props.hidePrimaryDisplay,
        primaryDisplayInline = _this$props.primaryDisplayInline,
        shortDisplay = _this$props.shortDisplay,
        typeDisplayInline = _this$props.typeDisplayInline,
        noLinkStyles = _this$props.noLinkStyles,
        detailedExtension = _this$props.detailedExtension;
      if (_.isEmpty(phoneNumber)) {
        return null;
      }
      var phoneNumberLength = _.get(phoneNumber, 'phone_number.length', 0);
      if (phoneNumber.extension) {
        phoneNumberLength += _.get(phoneNumber, 'extension.length', 0);
      }
      var phoneNumberWithNoAreaCode = phoneNumberLength === 7;
      var typeDisplay = phoneNumber.phone_type;
      var additionalInfo = /*#__PURE__*/React.createElement(CommunicationAdditionalInfo, {
        communicationTypes: phoneNumber.acceptable_communication_types,
        isPrimary: !hidePrimaryDisplay && phoneNumber.is_primary
      });
      var headerDisplay = /*#__PURE__*/React.createElement("span", {
        className: "subhead"
      }, " ", typeDisplay, " ", additionalInfo);
      var fullPhoneNumber = phoneNumber.extension ? _.get(phoneNumber, 'phone_number') + _.get(phoneNumber, 'extension') : _.get(phoneNumber, 'phone_number');
      var formattedPhoneNumber = formatPhoneNumber(fullPhoneNumber, detailedExtension);
      var doNotDisplayLink = this.props.noLink || phoneNumberWithNoAreaCode;
      if (doNotDisplayLink) {
        return /*#__PURE__*/React.createElement("div", {
          className: "phone-number-display",
          style: noLinkStyles
        }, /*#__PURE__*/React.createElement("span", detailedExtension && {
          'data-test-element': 'client_phone_number'
        }, formattedPhoneNumber), typeDisplay && typeDisplayInline && headerDisplay, primaryDisplayInline && !typeDisplayInline && headerDisplay);
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "phone-number-display"
      }, !shortDisplay && /*#__PURE__*/React.createElement("div", null, headerDisplay), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("a", _extends({
        href: getTelLink(phoneNumber, detailedExtension)
      }, detailedExtension && {
        'data-test-element': 'client_phone_number'
      }), formattedPhoneNumber)));
    }
  }, {
    key: "render",
    value: function render() {
      var phoneNumber = this.props.item;
      if (_.isEmpty(phoneNumber)) {
        return null;
      }
      return this.formattedPhoneLink(phoneNumber);
    }
  }]);
  return PhoneNumberDisplay;
}(Component);
PhoneNumberDisplay.propTypes = {
  item: PropTypes.object.isRequired,
  shortDisplay: PropTypes.bool,
  hidePrimaryDisplay: PropTypes.bool,
  noLink: PropTypes.bool,
  noLinkStyles: PropTypes.object,
  primaryDisplayInline: PropTypes.bool,
  typeDisplayInline: PropTypes.bool,
  detailedExtension: PropTypes.bool
};
PhoneNumberDisplay.defaultProps = {
  shortDisplay: false,
  hidePrimaryDisplay: false,
  noLink: false,
  primaryDisplayInline: false,
  typeDisplayInline: false,
  noLinkStyles: {
    marginTop: '3px'
  },
  detailedExtension: false
};
export default PhoneNumberDisplay;
//# sourceMappingURL=index.js.map